<div class="container">
  @if (loading) {
    <div class="loading-state">
      <div class="skeleton skeleton-meta"></div>
      <div class="skeleton skeleton-bigbar"></div>
      @for (_ of [1, 2, 3]; track $index) {
        <div class="skeleton-block">
          <div class="skeleton skeleton-setor-line"></div>
          @for (__ of [1, 2]; track $index) {
            <div class="skeleton skeleton-template"></div>
          }
        </div>
      }
    </div>
  } @else {
    @if (mes) {
      @if (!semDados()) {
        <div class="top">
          <div class="top-left"></div>

          <div class="meta-area">
            <div class="meta-row">
              <img class="meta-logo" src="assets/meta.svg" alt="Meta" />

              <button class="toggle" type="button" [class.on]="metaToggle" (click)="onToggleMeta()">
                <span class="dot"></span>
              </button>

              @if (metaToggle) {
                <div class="legend">
                  <span class="meta-legend-item">
                    <span class="meta-dot marketing"></span>
                    <span class="meta-text">Marketing</span>
                  </span>

                  <span class="meta-legend-item">
                    <span class="meta-dot utility"></span>
                    <span class="meta-text">Utilidade</span>
                  </span>

                  <span class="meta-legend-item">
                    <span class="meta-dot auth"></span>
                    <span class="meta-text">Autenticação</span>
                  </span>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="section">
          <div class="bigbar">
            @for (s of setoresOrdenados(); track s.setorNome; let i = $index) {
              <div class="bigseg" [style.width.%]="percentForBigBar(s.total, totalMes())"
                [style.background]="setorSegColor(i)">
                <div class="seg-label">
                  <div class="seg-pct">{{ setorPercentLabel(s.total) }}</div>
                  <div class="seg-name">{{ s.setorNome }}</div>
                </div>

                @if (metaToggle) {
                  <div class="seg-meta">
                    <span class="seg-meta-part mkt" [style.width.%]="percent(getSetorMetaTotal(s,'MARKETING'), s.total)"></span>
                    <span class="seg-meta-part utl" [style.width.%]="percent(getSetorMetaTotal(s,'UTILITY'), s.total)"></span>
                    <span class="seg-meta-part auth"
                      [style.width.%]="percent(getSetorMetaTotal(s,'AUTHENTICATION'), s.total)"></span>
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <div class="section">
          @for (s of setoresOrdenados(); track s.setorNome) {
            <div class="setor-block">
              <div class="setor-line">
                <span class="setor-badge">{{ s.setorNome }}</span>
                <span class="setor-rule"></span>
                <span class="setor-value">{{ formatUSD(s.total) }}</span>
              </div>

              <div class="templates">
                @for (t of s.porTemplate; track t.templateNome) {
                  <div class="tpl">
                    <div class="tpl-name">{{ t.templateNome }}</div>

                    <div class="tpl-bar-row">
                      <div class="tpl-bar">
                        <div class="tpl-total-inside">{{ formatUSD(s.total) }}</div>

                        <div class="tpl-fill-layer" [class.meta-on]="metaToggle">
                          @if (!metaToggle) {
                            <div class="tpl-fill" [style.width.%]="percent(t.total, s.total)"></div>
                          } @else {
                            <div class="tpl-fill meta mkt" [style.width.%]="percent(getMetaPart(t,'MARKETING'), s.total)"></div>
                            <div class="tpl-fill meta utl" [style.width.%]="percent(getMetaPart(t,'UTILITY'), s.total)"></div>
                            <div class="tpl-fill meta auth" [style.width.%]="percent(getMetaPart(t,'AUTHENTICATION'), s.total)">
                            </div>
                          }
                        </div>
                      </div>

                      <div class="tpl-val">{{ formatUSD(t.total) }}</div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="empty-state">
          <app-balao-aviso texto="Nenhuma informação encontrada para o período"></app-balao-aviso>
        </div>
      }
    } @else {
      <div class="container">
        <div class="empty-state">
          <app-balao-aviso texto="Nenhuma informação encontrada para o período"></app-balao-aviso>
        </div>
      </div>
    }
  }
</div>
